package com.sddamico.swigmore.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import kotlinx.coroutines.delay
import kotlin.js.Date

/** Epoch ms, refreshed every [intervalMs]. */
@Composable
fun rememberNow(intervalMs: Long = 1_000): Long {
  var now by remember { mutableStateOf(Date.now().toLong()) }
  LaunchedEffect(intervalMs) {
    while (true) {
      delay(intervalMs)
      now = Date.now().toLong()
    }
  }
  return now
}
